import React from 'react';

export default function Footer() {
  return (
    <footer className='footer'>
      <div className='footer__copirating-container'>
        {/* <h2 className='footer__copirating'>С уважением и любовью!</h2> */}
        <p className='footer__copirating'>
          &copy; {new Date().getFullYear()} Титов А.В.
        </p>
      </div>
      <div className='footer__links'>
        <h2 className='footer__copirating'>Контакты для связи:</h2>
        <a
          href='Tel:89101636692'
          target='_blank'
          rel='noreferrer'
          className='footer__link'
        >
          Мой телефон: 8 (910) 163-66-92
        </a>
        <a
          href='mailto:N3kto.1@yandex.ru?body=У твоего любимого пользователя появился вопрос'
          target='_blank'
          rel='noreferrer'
          className='footer__link'
        >
          Моя почта: N3kto.1@yandex.ru
        </a>
        <a
          href='https://vk.com/idtens91'
          className='footer__link'
          target='_blank'
          rel='noreferrer'
        >
          Мой VK
        </a>
      </div>
    </footer>
  );
}
